<template>
  <div class="partners">

    <div class="partners-heading block-heading-font-style">THE ENTIRE FAMILY OF ATTACH</div>
    <div class="partners-subheading block-subheading-font-style">MikMak has an Attach experience for every stage in the shopper's journey.</div>

    <div class="all-attach-items">
      <span class="attach-item" v-for="attachProduct in attachFamilyList">
        <img :src="getImgUrl(attachProduct.slug)">
        <span :class="`attach-item-title attach-product-badge badge-for-${attachProduct.slug}`">{{ attachProduct.name }}</span>
      </span>
    </div>

    <!-- <div class="explore-blocks-wrapper">
      <div class="explore-block">
        Explore by Industry
        <a :href="industry.link" v-for="industry in industries">{{ industry.title }}</a>
      </div>

      <div class="explore-block">
        Explore by Solution
        <a :href="solution.link" v-for="solution in solutions">{{ solution.title }}</a>
      </div>
    </div> -->

    <a href="#contact-footer" v-on:click="clickedRequestDemoButton()" class="attach-item-request-demo-button">Request a demo of all Attach</a>

  </div>
</template>

<script>

// Upload more images here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview

import eventDispatcher from '../events/dispatch'

export default {
  mounted() {},
  methods: {
    getImgUrl(slug) {
      return `//mikmak.s3.amazonaws.com/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/attach-${slug}.png`
    },
    clickedRequestDemoButton() {
      let message = 'Clicked request button on Family of Attach area.'
      if (!window.mmProductInterests) window.mmProductInterests = []
      window.mmProductInterests.push(message)

      eventDispatcher('requestDemoClicked', {
        sourceOfDemo: message
      })

      this.resetScroll()
    },
    resetScroll() {
      setTimeout(() => {
        window.scrollBy(0, -48)
      }, 10)
    }
  },
  computed: {
    attachFamilyList() {
      return this.$store.state.attachFamilyList
    },
    solutions() {
      return this.$store.state.solutionsAndIndustries.solutions
    },
    industries() {
      return this.$store.state.solutionsAndIndustries.industries
    }
  },
  watch: {}
}
</script>

<style scoped>

  .partners {
    display: block;
    background: white;
    padding: 24px 0;
  }

  .partner-logos {
    display: block;
    text-align: center;
    width: 90%;
    margin: 0 auto;
    text-align: center;
    margin-top: 24px;
  }

  @media only screen and (max-width: 800px) {
    .partner-logos {
      width: 100%;
    }
  }

  .partner-logos img {
    display: inline-block;
    width: 124px;
    margin: 12px 24px;
    opacity: 0.5;
  }

  @media only screen and (max-width: 800px) {
    .partner-logos img {
      display: inline-block;
      width: 70px;
      margin: 0 12px;
    }
  }

  @media only screen and (max-width: 450px) {
    .partner-logos img {
      display: inline-block;
      width: 40px;
      margin: 8px;
    }
  }

  .all-attach-items {
    display: block;
    text-align: center;
    margin: 12px;
    font-family: 'Work Sans', sans-serif;
  }

  .attach-item {
    display: inline-block;
    vertical-align: top;
    margin: 12px;
  }

  .attach-item img {
    width: 100px;
    display: inline-block;
    vertical-align: top;
  }

  @media only screen and (max-width: 650px) {
    .attach-item {
      margin: 12px 2px;
    }
    .attach-item img {
      width: 80px;
    }
    .attach-product-badge {
      width: 80px;
    }
  }

  .attach-item-title {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1px;
    white-space: normal;
    max-width: 150px;
    margin: 0 auto;
    margin-top: 12px;
  }

  @media only screen and (max-width: 650px) {
    .attach-item-title {

    }
  }

  .attach-product-badge {
    padding: 2px 8px;
    border-radius: 2px;
    text-align: left;
    padding-left: 10px;
    text-align: center;
  }
/*
  .badge-for-cart {
    background: #0088bc;
    color: white;
  }

  .badge-for-multicart {
    background: #925eef;
    color: white;
  }

  .badge-for-rate {
    background: #4ac177;
    color: white;
  }

  .badge-for-gallery {
    background: #DAB65F;
    color: white;
  }

  .badge-for-convert {
    background: #e86f6f;
    color: white;
  }

  .badge-for-convert-variant {
    background: #d4d85e;
    color: white;
  }

  .badge-for-capture {
    background: #8cc0f1;
    color: white;
  } */

  .attach-item-request-demo-button {
    background: #409dd4;
    background: #00a9bc;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00a9bc', endColorstr='#00bfbd',GradientType=1 );
    color: white;
    font-size: 22px;
    min-width: 224px;
    max-width: 300px;
    text-align: center;
    padding: 8px;
    border-radius: 3px;
    margin: 24px auto;
    display: block;
    cursor: pointer;
    box-shadow: 0px 2px 6px #00000024;
    font-weight: lighter;
    text-decoration: none;
    letter-spacing: 1px;
  }

  .explore-blocks-wrapper {
    display: block;
    width: 70%;
    margin: 0 auto;
    background: #fdfdfd;
    padding: 6px 12px;
    border-radius: 3px;
    border: 1px solid #e4e4e4;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .explore-block {
    display: block;
    text-align: center;
    font-size: 14px;
    font-family: 'Work Sans', sans-serif;
    margin: 12px auto;
  }

  .explore-block a {
    color: #00BFBD;
    display: inline-block;
    margin: 12px;
    transition: ease-in-out 0.225s;
  }

  @media only screen and (max-width: 650px) {
    .explore-block a {
      display: block;
    }
    .explore-blocks-wrapper {
      width: 90%;
    }
  }

  .explore-block a:hover {
    opacity: 0.8;
  }

</style>



// WEBPACK FOOTER //
// AttachFamily.vue?5cc72482